module.exports = __webpack_public_path__ + "img/l-5.3e4d4083.jpg";